import { createFileRoute } from "@tanstack/react-router";
import { ArticleLayout } from "@/components/article-layout";
import { getArticle } from "@/content/articles";
import { abs, articleHead } from "@/content/seo";
import ogSocial from "@/assets/og-sylwia-sitkowska.jpg";

const article = getArticle("mastermind-dla-przedsiebiorcow");

export const Route = createFileRoute("/mastermind-dla-przedsiebiorcow")({
  head: () => articleHead(article, abs(ogSocial)),
  component: () => <ArticleLayout article={article} />,
});
